<template>
  <div class="kbSemiExtraLightGray d-flex align-center justify-space-between pa-3"
       style="height: 60px;
              min-width: calc(100% + 24px);
              max-width: calc(100% + 24px);
              position: relative;
              transform: translate(-12px, -12px);
              z-index: 3">
    <div class="pl-2 d-flex align-center">
      <span class="kbGray--text text-uppercase text-h6"
            style="cursor: pointer"
            @click="goToSequences()">
        {{ $t('general.sequences') }}
      </span>

      <v-icon class="mx-2"
              color="kbBlue">
        mdi-arrow-right
      </v-icon>

      <span class="kbBlue--text text-uppercase text-h6">
        {{ sequence.name }}
      </span>
    </div>

    <SequencePeopleAndStepsIndicators :sequence="sequence" />

    <div class="d-flex align-center align-self-stretch">
      <v-tooltip bottom
                 v-for="(action, index) in actionButtons"
                 :key="index">
        <template v-slot:activator="{ on }">
          <v-btn color="kbBlue"
                 class="mx-1"
                 height="45px"
                 icon
                 width="45px"
                 v-on="on"
                 @click="action.function()">
            <v-icon size="35px">{{ action.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ action.name }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import SequencePeopleAndStepsIndicators from '@/pages/App/Sequences/SequencePeopleAndStepsIndicators'
export default {
  components: { SequencePeopleAndStepsIndicators },
  computed: {
    actionButtons () {
      const vue = this
      let viewTypeIcon = 'mdi-cards-variant'
      let viewTypeName = 'See cards view'
      let viewType = 'cards'

      if (this.viewType === 'cards') {
        viewTypeIcon = 'mdi-format-list-bulleted'
        viewTypeName = 'See list view'
        viewType = 'list'
      }

      return [
        {
          icon: viewTypeIcon,
          name: viewTypeName,
          function () { vue.changeSequenceViewType(viewType) }
        },
        { icon: 'mdi-chart-bar', name: this.$t('general.statistics'), function () { vue.$router.push({ name: 'Sequence Statistics' }) } },
        { icon: 'mdi-plus-circle', name: this.$t('general.add'), function () { vue.showAddPersonOrStepDialog() } },
        {
          icon: 'mdi-cog',
          name: this.$t('general.settings'),
          function () {
            vue.$router.push({
              name: 'Sequence Details',
              params: { appid: vue.$route.params.appid, sequenceId: vue.$route.params.sequenceId }
            })
          }
        }
      ]
    }
  },
  methods: {
    changeSequenceViewType (viewType) {
      this.$emit('changeSequenceViewType', viewType)
    },
    goToSequences () {
      this.$router.push({ name: 'Sequences', params: { appid: this.$store.getters.appUuid } })
    },
    showAddPersonOrStepDialog () {
      this.$emit('showAddPersonOrStepDialog')
    }
  },
  props: {
    sequence: {
      type: Object,
      default: () => {}
    },
    viewType: {
      type: String,
      required: true
    }
  }
}
</script>
